import React from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import LoginForm from '../Components/LoginForm';
import { useAuth } from '../Contexts/AuthContext';
import { Navigate } from 'react-router-dom';

const LoginPage = () => {
  const { isAuthenticated } = useAuth();
  
  // If already authenticated, redirect to admin page
  if (isAuthenticated) {
    return <Navigate to="/admin/keywords" replace />;
  }
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header isMainPage={false} />
      
      <main className="flex-grow flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900">Genomii Admin</h1>
            <p className="mt-2 text-gray-600">
              Please login to access the admin dashboard
            </p>
          </div>
          
          <LoginForm />
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default LoginPage;